import { Link } from 'react-router-dom';
import '../css/Sports.css';
import soccer from '../assets/soccer.jpg';
import football from '../assets/football.jpg';

const Sports = () => {
    return (
        <main id="sport-content">
            <h2 id="quest">What Sport Would You Like To See?</h2>

            <section id="sport-section">
                <Link to="/sports/soccer">
                    <section id="sport-section">
                        <div id="sport-container">
                            <img id="teams-img" src={soccer} alt="Soccer" />
                        </div>
                    </section>
                </Link>

                <Link to="/sports/football">
                    <section id="sport-section">
                        <div id="sport-container">
                            <img id="teams-img" src={football} alt="Football" />
                        </div>
                    </section>
                </Link>
            </section>
        </main>
    );
};

export default Sports;